module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('transition', {
    attrs: {
      "name": "fade"
    }
  }, [_c('div', {
    staticClass: "absolute top-0 left-0 bottom-0 right-0 z-9999 overflow-hidden bg-black-40 fade overflow-y-scroll flex",
    attrs: {
      "id": "overlay",
      "tabindex": "-1",
      "role": "dialog"
    },
    on: {
      "click": _vm.closeModal
    }
  }, [_c('div', {
    staticClass: "bg-white ba b--light-gray br2 mw6 center-custom animated-slow slide-in",
    class: _vm.upsell ? 'upsell' : '',
    attrs: {
      "id": "modal"
    }
  }, [_c('div', {
    staticClass: "pt4 ph4 flex justify-between",
    class: _vm.upsell ? 'upsell-title' : ''
  }, [_c('div', {
    staticClass: "ma0 f4"
  }, [_vm._v(_vm._s(_vm.title))]), _vm._v(" "), _c('div', {
    staticClass: "right f5 pointer",
    attrs: {
      "aria-hidden": "true"
    },
    on: {
      "click": _vm.emitClose
    }
  }, [_vm._v("✕")])]), _vm._v(" "), _c('div', {
    staticClass: "ph3"
  }, [_vm._t("modal-body", function() {
    return [_vm._v("Placeholder modal body")]
  })], 2), _vm._v(" "), _vm._t("modal-footer", function() {
    return [_c('div', {
      staticClass: "pa3 flex justify-end"
    }, [_c('ak-button', {
      attrs: {
        "secondary": ""
      },
      nativeOn: {
        "click": function($event) {
          return _vm.emitClose.apply(null, arguments)
        }
      }
    }, [_vm._v("Close")])], 1)]
  })], 2)])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-4501cbd8","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/ModalWithoutInnerBorder.vue
// module id = 1008
// module chunks = 0